module.exports = __webpack_public_path__ + "media/images/jan-320255678508350142ebac64f556e6a9.png";